export default class SavedItemsModalSubview {
    constructor(parent) {
        this.saveModal = parent.el.querySelector('.saved-configuration-modal');

        if (this.saveModal) {
            this.closeModalCta = this.saveModal.querySelector('.modal-close');
            this.cancelCta = this.saveModal.querySelector('.secondary-button');
            this.confirmCta = this.saveModal.querySelector('.primary-button');
            this.bind();
        }
    }

    bind() {
        this.closeModalCta?.addEventListener('click', () => this.close());
        this.cancelCta?.addEventListener('click', () => this.close());
        this.confirmCta?.addEventListener('click', () => this.remove());
        window.addEventListener('click', (event) => {
            if (event.target === this.saveModal) {
                this.close();
            }
        });
    }

    show(id) {
        if (this.saveModal) {
            this.removalId = id;
            this.saveModal.classList.remove('hide');
        }
    }

    remove() {
        window.HONDA.SaveForLater?.saveForLater?.remove({ data: { id: this.removalId } });
        this.close();
    }

    close() {
        this.saveModal?.classList.add('hide');
    }
}
